class VGForms {
	constructor() {
		this.init = this.initFieldsLogic();
	}

	initFieldsLogic() {
		const passwordFields = document.querySelectorAll(
			".vg-form__field-group--password"
		);
		const datepickerToggle = document.querySelectorAll(
			".datepicker-toggle-button"
		);
		const phoneElement = document.querySelectorAll(
			".vg-form__field-element-phone"
		);
		const selectElement = document.querySelectorAll(
			".vg-form__field-element-select"
		);

		if (passwordFields) {
			this.initFieldLogicPassword(passwordFields);
		}

		if (datepickerToggle) {
			this.initFieldLogicDate(datepickerToggle);
		}

		if (phoneElement) {
			this.initFieldLogicPhone(phoneElement);
		}

		if (selectElement) {
			this.initFieldLogicSelect(selectElement);
		}
	}

	/** FIELD LOGIC METHODS */

	initFieldLogicPassword(passwordFields) {
		passwordFields.forEach((fieldPassword) => {
			const inputPassword = fieldPassword.querySelector("input");
			const icon_eye = fieldPassword.querySelector(".icon--eye");
			const tooltip = fieldPassword.querySelector("vg-tooltip");

			if (0 < inputPassword.value.length) {
				if (null != tooltip) {
					tooltip.style.display = "none";
				}
				if (null != icon_eye) {
					icon_eye.style.display = "flex";
				}
			}

			if (null != tooltip) {
				inputPassword.addEventListener("keyup", (input) => {
					if (!icon_eye || !tooltip) return;
					icon_eye.style.display = "none";
					tooltip.style.display = "flex";

					if (0 < input.target.value.length) {
						icon_eye.style.display = "flex";
						tooltip.style.display = "none";
					}
				});
			}

			if (null != icon_eye) {
				icon_eye.addEventListener("click", () => {
					if ("password" === inputPassword.type) {
						inputPassword.type = "text";
						icon_eye.classList.remove("icon--eye");
						icon_eye.classList.add("icon--eye-close");
					} else {
						inputPassword.type = "password";
						icon_eye.classList.remove("icon--eye-close");
						icon_eye.classList.add("icon--eye");
					}
				});
			}
		});
	}

	initFieldLogicDate(datepickerToggle) {
		datepickerToggle.forEach((toggle) => {
			const MIN_AGE = 14;
			const parent = toggle.parentElement;
			const calendar = parent.querySelector("input[type='date']");

			if (calendar.getAttribute("name") === "birthday") {
				const today = new Date();
				const maxDate = new Date(
					today.getFullYear() - MIN_AGE,
					today.getMonth(),
					today.getDate()
				);
				const maxDateString = maxDate.toISOString().split("T")[0];
				calendar.setAttribute("max", maxDateString);
			}

			toggle.addEventListener("click", (event) => {
				if (calendar.showPicker) {
					calendar.showPicker();
				}
			});
			calendar.addEventListener("click", (event) => {
				if (calendar.showPicker) {
					calendar.showPicker();
				}
			});
		});
	}

	initFieldLogicPhone(phoneElement) {
		phoneElement?.forEach((element) => {
			const select_ = element.querySelector("select");

			select_?.addEventListener("click", (event) => {
				const wrapper_select = select_.closest(
					".vg-form__field-prefix-wrapper"
				);
				if (wrapper_select.classList.contains("select-open")) {
					wrapper_select.classList.remove("select-open");
				} else {
					wrapper_select.classList.add("select-open");
				}
			});
		});
	}

	initFieldLogicSelect(selectElement) {
		selectElement.forEach((element) => {
			const selectElement = element.querySelector("select");
			const selectWrapper = selectElement.closest(".vg-form__field-select-wrapper");

			selectElement.addEventListener("focus", (event) => {
				selectWrapper.classList.add("select-open");
			});
	
			selectElement.addEventListener("blur", (event) => {
				selectWrapper.classList.remove("select-open");
			});

			selectElement.addEventListener("mousedown", (event) => {
				if (event.target === selectElement) {
					if (selectWrapper.classList.contains("select-open")) {
						selectWrapper.classList.remove("select-open");
					} else {
						selectWrapper.classList.add("select-open");
					}
				}
			});
		});
	}

	/** FIELDS VALUES MANIPULATION */

	getFieldValue(fieldName) {
		const field = document.querySelector(`[name='${fieldName}']`);
		if (field) {
			return field.value;
		}
		return null;
	}

	setFieldOnlyRead(fieldName) {
		const fields = document.querySelectorAll(`[name='${fieldName}']`);
		if (fields.length === 1) {
			const field = fields[0];
			field.readOnly = true;
			field.classList.add('vg-color-text-gray');
		} else {
			// For radio buttons (multiple inputs with the same name)
			fields.forEach((field) => {
				field.readOnly = true;
				field.classList.add('vg-color-text-gray');
			});
		}
	}

	removeFieldDisabled(fieldName) {
		const fields = document.querySelectorAll(`[name='${fieldName}']`);
		if (fields.length === 1) {
			const field = fields[0];
			if (field.hasAttribute("disabled")) {
				field.disabled = false;
			}
		} else {
			// For radio buttons (multiple inputs with the same name)
			fields.forEach((field) => {
				if (field.hasAttribute("disabled")) {
					field.disabled = false;
				}
			});
		}
	}

	setCheckboxValue(fieldName, value) {
		if (value === true) {
			document.querySelector(`[name='${fieldName}']`).checked = true;
		}
		if (value === false) {
			document.querySelector(`[name='${fieldName}']`).checked = false;
		}
	}

	setFieldValue(fieldName, value) {
		const fields = document.querySelectorAll(`[name='${fieldName}']`);
		if (fields.length === 1) {
			const field = fields[0];
			field.value = value;
		} else {
			// For radio buttons (multiple inputs with the same name)
			fields.forEach((field) => {
				if (field.type === "radio" && field.value === value) {
					field.checked = true;
				}
			});
		}
	}

	setFormValues(data) {
		Object.keys(data).forEach((key) => {
			this.setFieldValue(key, data[key]);
		});
	}

	/** FIELD VALIDATION METHODS*/

	fieldsLiveValidation(constraints) {
		constraints.forEach((element) => {
			let inputElement = document.querySelector(
				`${element.type}[name='${element.field_name}']`
			);
			if (inputElement == null) {
				console.log(`Validation, skipping ${element.name}`);
				return;
			}
			inputElement.addEventListener("input", (event) => {
				this.isValid(
					event.target.value,
					inputElement,
					element.constraints
				);
			});
		});
	}

	fieldsValidation(constraints) {
		console.log("Validating fields", constraints);
		let isValidForm = true;
		constraints.forEach((element) => {
			let inputElement = document.querySelector(
				`${element.type}[name='${element.field_name}']`
			);
			if (inputElement == null || inputElement.hasAttribute("disabled")) {
				console.log(`Validation, skipping ${element.name}`);
				return;
			}

			let inputValue = inputElement.value;

			if (inputElement.type == "radio") {
				inputValue = this.getInputRadioValue(element.field_name);
			}

			let isValidInput = this.isValid(
				inputValue,
				inputElement,
				element.constraints
			);

			if (!isValidInput) {
				isValidForm = false;
			}
		});
		return isValidForm;
	}

	getInputRadioValue(selector) {
		let selectedOption = "";
		const radios = document.querySelectorAll(`input[name="${selector}"]`);

		radios.forEach((radio) => {
			if (radio.checked) {
				selectedOption = radio.value;
			}
		});

		return selectedOption;
	}

	getFieldConstraint(fieldName, constraints) {
		return constraints.find((element) => element.field_name === fieldName);
	}

	isValid(value, element, rules) {
		if (element.hasAttribute("disabled")) {
			return;
		}
		let message = "";
		let messageType;
		let isValid = true;
		let stopValidation = false;
		let messageConditional = "";
		let totalRegexp = 0;

		if (element.name === 'id-number') {
			value = value.replace("-", "");
		}

		console.log("Validating " + element.name + " : " + value);

		rules.forEach((rule) => {
			if (stopValidation) {
				return;
			}
			if (rule.rule == "max_length") {
				if ( value.length > rule.params.max_length ) {
					messageType = "error";
					isValid = false;
					console.log("'max_length KO " + rule.params.value);
				} else {
					messageType = "success";
					console.log("max_length OK " + value.length);
				}
			}
			if (rule.rule == "min_length") {
				if (
					value.length < rule.params.min_length ||
					value.length == 0
				) {
					messageType = "error";
					isValid = false;
					console.log("min_length KO " + rule.params.value);
				} else {
					messageType = "success";
					console.log("min_length OK " + value.length);
				}
			}
			if (rule.rule == "required") {
				if (value.length == 0 || value == null || value == "" || value == " " || value == undefined || element.type == "checkbox" && !element.checked) {
					messageType = "error";
					isValid = false;
					console.log("required KO " + rule.params.value);
				} else {
					messageType = "success";
					console.log("required OK " + value.length);
				}
			}
			if (rule.rule == "regexp") {
				const regex = (rule.params.regexp instanceof RegExp) ? rule.params.regexp : new RegExp(rule.params.regexp);
				if (!regex.test(value)) {
					messageType = "error";
					isValid = false;
					console.log("regexp KO " + regex);
				} else {
					totalRegexp += 1;
					messageType = "success";
					console.log("regexp OK " + value);
				}
			}
			if (rule.rule == "conditional_regexp") {
				const masterFieldValue = this.getFieldValue(
					rule.params.field_master
				);

				if (!masterFieldValue || masterFieldValue === null) {
					console.error("Master field not found");
					return;
				}

				const regexpEntry = rule.params.regexp[masterFieldValue];
				messageConditional = rule.params.error_message[masterFieldValue];

				if (!regexpEntry || !messageConditional) {
					console.error(
						"Master field not found in regexp or message"
					);
					return;
				}

				const regex = (regexpEntry instanceof RegExp) ? regexpEntry : new RegExp(regexpEntry);

				if (false == regex.test(value)) {
					messageType = "error";
					isValid = false;
					console.log("regexp KO " + regex);
				} else {
					messageType = "success";
					console.log("regexp OK " + value.length);
				}
			}

			if (rule.params.stopper && !isValid) {
				stopValidation = true;
			}
			if (element.name == "password" || element.name == "password-confirm") {
				message += `<span class="${messageType}">${rule.params.error_message}</span>`;
			} else {
				message = `<span class="${messageType}">${rule.params.error_message}</span>`;
				if (rule.rule == "conditional_regexp") {
					message = `<span class="${messageType}">${messageConditional}</span>`;
				}
			}
		});


		//extra validation for Inputs with a Date
		if (element.name === "birthday" && isValid) {
			const englishDateString = value.split('/').reverse().join('-');
			const dateSelected = new Date(englishDateString);

			if (!this.isGoodFormatedDate(dateSelected)) {
				isValid = false;
				messageType = "error";
				return;
			}

			const hasEnoughAge = this.hasEnoughAge(dateSelected);
			if (typeof hasEnoughAge === 'string' ) {
				isValid = false;
				message = hasEnoughAge;
			}
		}

		if (element.name === "password" || element.name === "password-confirm") {
			if (totalRegexp>=3 && value.length >= 8) { // TODO: better management of password rules
				isValid = true;
			}
		}

		if (element.name === "account-holder-iban") {
			if (this.isValidIban(element.value)) {
				isValid = true;
			} else {
				isValid = false;
				message = "IBAN no valido";
			}
		}

		if (element.name === "phone" && isValid) {
			let phoneWithoutPrefix = element.value;

			const prefix = document.querySelector(".iti__selected-dial-code").innerHTML;

			if (prefix === '+34') {
				isValid = ( phoneWithoutPrefix[0] === '6' ) || ( phoneWithoutPrefix[0] === '7' ) && ( phoneWithoutPrefix.replace(/\s+/g, '').length === 9 );
			}
			if (prefix === '+351') {
				isValid = ( phoneWithoutPrefix[0] === '9' ) && ( phoneWithoutPrefix.replace(/\s+/g, '').length === 9 );
			}

			if ( !(isValid) ) {
				message = JoiningVars.get_form_field("user-data").phone_invalid;
			}
		}


		this.showErrorElement(element, message);
		if (isValid) {
			this.removeErrorElement(element);
		}
		return isValid;
	}


	isValidIban(iban) {
		if (typeof iban === 'string' && iban.length > 6) {
			let countryCode = iban.substring(0, 2).toUpperCase();
			return this.validateFormat(countryCode, iban);
		} else {
			return false;
		}
	}

	validateFormat(countryCode, iban) {
		const validators = {
			'AD': /^AD\d{10}[A-Z0-9]{12}$/,
			'AT': /^AT\d{18}$/,
			'BE': /^BE\d{14}$/,
			'BG': /^BG\d{2}[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
			'CH': /^CH\d{7}[A-Z0-9]{12}$/,
			'CY': /^CY\d{10}[A-Z0-9]{16}$/,
			'CZ': /^CZ\d{22}$/,
			'DE': /^DE\d{20}$/,
			'DK': /^DK\d{16}$/,
			'EE': /^EE\d{18}$/,
			'ES': /^ES\d{22}$/,
			'FI': /^FI\d{16}$/,
			'FR': /^FR\d{12}[A-Z0-9]{11}\d{2}$/,
			'GB': /^GB\d{2}[A-Z]{4}\d{14}$/,
			'GI': /^GI\d{2}[A-Z]{4}[A-Z0-9]{15}$/,
			'GR': /^GR\d{9}[A-Z0-9]{16}$/,
			'HR': /^HR\d{19}$/,
			'HU': /^HU\d{26}$/,
			'IE': /^IE\d{2}[A-Z]{4}\d{14}$/,
			'IS': /^IS\d{24}$/,
			'IT': /^IT\d{2}[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
			'LI': /^LI\d{7}[A-Z0-9]{12}$/,
			'LT': /^LT\d{18}$/,
			'LU': /^LU\d{5}[A-Z0-9]{13}$/,
			'LV': /^LV\d{2}[A-Z]{4}[A-Z0-9]{13}$/,
			'MC': /^MC\d{12}[A-Z0-9]{11}\d{2}$/,
			'MT': /^MT\d{2}[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
			'NL': /^NL\d{2}[A-Z]{4}\d{10}$/,
			'NO': /^NO\d{13}$/,
			'PL': /^PL\d{26}$/,
			'PT': /^PT\d{23}$/,
			'RO': /^RO\d{2}[A-Z]{4}[A-Z0-9]{16}$/,
			'SE': /^SE\d{22}$/,
			'SI': /^SI\d{17}$/,
			'SK': /^SK\d{22}$/,
			'VA': /^VA\d{20}$/
		};

		const cleanedIban = iban.replace(/\s+/g, '');
		return validators[countryCode].test(cleanedIban);
	}

	isGoodFormatedDate(dateSelected) {
		if (Object.prototype.toString.call(dateSelected) !== "[object Date]") {
			console.log("KO Bad formatted Date -->", dateSelected);
			return false;
		} else {
			if (isNaN(dateSelected)) {
				console.log("KO Bad formatted Date isNAN --> ", dateSelected);
				return false;
			}
			const currentYear = new Date().getFullYear();
			if (dateSelected.getFullYear() > currentYear) {
				console.log("KO Date year is in the future -->", dateSelected);
				return false;
			}
		}
		return true;
	}

	hasEnoughAge(dateSelected) {
		const yearDiff = this.calculateAge(dateSelected);
		const countrySelected = document.querySelector(
			"select[name='country']"
		).value;
		if (countrySelected === 'pt') {
			if (yearDiff<16) {
				console.log("KO Not enough Age 16", dateSelected);
				return `<span class="error">Debes ser mayor de 16 años para darte de alta</span>`;
			}
		} else {
			if (yearDiff<14) {
				console.log("KO Not enough Age 14", dateSelected);
				return `<span class="error">Debes ser mayor de 14 años para darte de alta</span>`;
			}
		}

		return true;
	}

	calculateAge(birthday)
	{
		var ageDifMs = Date.now() - birthday - 86400000;
		var ageDate = new Date(ageDifMs); // miliseconds from epoch.
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	}

	removeErrorElement(element) {
		const elementGroup = element.closest(".vg-form__field-group");
		if (elementGroup?.querySelectorAll(".hasClass").length > 0) {
			elementGroup.classList.remove("has-error");
			elementGroup.querySelectorAll(".hasClass").forEach((element) => {
				element.remove();
			});
			elementGroup.classList.add("has-success");
		}
	}

	showErrorElement(element, message) {
		this.removeErrorElement(element);
		const parentElement = element.closest(".vg-form__field-group");

		if (0 == parentElement.querySelectorAll(".hasClass").length) {
			parentElement.classList.add("has-error");
			const newElement = document.createElement("div");
			newElement.classList.add("hasClass");
			newElement.classList.add("vg-form__field-message");
			newElement.innerHTML = message;
			parentElement.appendChild(newElement);
			parentElement.classList.remove("has-success");
			parentElement.classList.add("has-error");
		} else {
			// TODO: This is not necessary, confirm if it can be removed
			//parentElement.querySelectorAll(".vg-form_field-message").remove();
		}
	}

	isValidDNI(dni) {
		const number = parseInt(dni.slice(0, -1), 10);
		const letter = dni.slice(-1).toUpperCase();
		const expectedLetter = "TRWAGMYFPDXBNJZSQVHLCKE".charAt(number % 23);

		return letter === expectedLetter;
	}

	isValidNIE(nie) {
		const prefix = nie.charAt(0).toUpperCase();
		let number = nie.slice(1, -1);
		const letter = nie.slice(-1).toUpperCase();

		switch (prefix) {
			case "X":
				number = "0" + number;
				break;
			case "Y":
				number = "1" + number;
				break;
			case "Z":
				number = "2" + number;
				break;
			default:
				return false; // Invalid prefix
		}

		number = parseInt(number, 10);
		const expectedLetter = "TRWAGMYFPDXBNJZSQVHLCKE".charAt(number % 23);

		return letter === expectedLetter;
	}

	isValidNIF(nif) {
		let isValid = true;
		const nifRegex = /^[0-9]{9}$/;
		if (!nifRegex.test(nif)) {
			isValid = false;
		}
		return isValid;
	}

	initGymSelector(regionSelect, gymSelect, selectdGymId = null) {

		if (!regionSelect || !gymSelect) return;

		const originalGymOptions = Array.from(gymSelect.options);

		regionSelect.addEventListener('change', function () {
			const selectedOption = regionSelect.options[regionSelect.selectedIndex];
			let gymIds = selectedOption.getAttribute('data-gyms') || '';

			if (!selectedOption.value) {
				gymSelect.innerHTML = '';
				originalGymOptions.forEach(option => gymSelect.appendChild(option.cloneNode(true)));
				gymSelect.selectedIndex = 0;
				return;
			}

			gymIds = gymIds.replace(/&quot;/g, '').replace(/^"|"$/g, '');
			gymIds = gymIds.split(',').map(id => id.trim()).filter(id => id !== '');

			gymSelect.innerHTML = '';

			if (gymIds.length > 1) {
				const defaultOption = originalGymOptions.find(option => option.value === '');
				if (defaultOption) {
					gymSelect.appendChild(defaultOption.cloneNode(true));
				}
			}

			gymIds.forEach(gymId => {
				const gymOption = originalGymOptions.find(option => option.value === gymId);
				if (gymOption) {
					gymSelect.appendChild(gymOption.cloneNode(true));
				} else {
					console.warn("Gym ID no encontrado:", gymId);
				}
			});

			if (gymIds.length === 1) {
				gymSelect.selectedIndex = 0;
				const selectedOption = gymSelect.options[0];
				selectedOption.selected = true;
				selectedOption.dispatchEvent( new Event('change', { bubbles: true }) );
			}
		});

		if (selectdGymId) {
			this.setGymSelector(regionSelect, gymSelect, selectdGymId);
		}
	}

	setGymSelector(regionSelect, gymSelect, selectdGymId) {
		const regionOptions = Array.from(regionSelect.options);
		const matchRegions  = [];

		regionOptions.forEach(option => {
			const gyms = option.getAttribute("data-gyms");
			const match = gyms?.indexOf(selectdGymId) != -1;
			if (match) {
				matchRegions.push(option);
			}
		});

		const lastMatch = matchRegions[matchRegions.length - 1]; // last match is the nearest location
		
		if (lastMatch) {
			lastMatch.selected = true;
			regionSelect.dispatchEvent(new Event('change'), { bubbles: true });

			gymSelect.value = selectdGymId;
			gymSelect.dispatchEvent(new Event('change'), { bubbles: true });

			regionSelect.setAttribute("disabled", "disabled");
			gymSelect.setAttribute("disabled", "disabled");
		}
	}


	/** HELPERS */

	addLoading(element) {
		element.classList.add("is-loading");
	}

	removeLoading(element) {
		element.classList.remove("is-loading");
	}
}
